import type { CarCardData } from "@/lib/api";

/**
 * Keep the nearby homepage rail useful after the primary rail has claimed
 * its best conversion candidates. The input order is already the nearby
 * search order, so this helper only removes cross-rail duplicates and makes
 * a bounded diversity pass without replacing the canonical ranker.
 */
export function selectNearbyAlternatives(
  cars: CarCardData[],
  excludedIds: ReadonlySet<number>,
): CarCardData[] {
  const uniqueCandidates: CarCardData[] = [];
  const seenIds = new Set<number>();

  for (const car of cars) {
    if (excludedIds.has(car.id) || seenIds.has(car.id)) continue;
    seenIds.add(car.id);
    uniqueCandidates.push(car);
  }

  if (uniqueCandidates.length < 2) return uniqueCandidates;

  const diverse: CarCardData[] = [];
  const deferred: CarCardData[] = [];
  const seenModels = new Set<string>();

  for (const car of uniqueCandidates) {
    const modelKey = `${car.make.trim().toLowerCase()}::${car.model.trim().toLowerCase()}`;
    if (seenModels.has(modelKey)) {
      deferred.push(car);
      continue;
    }
    seenModels.add(modelKey);
    diverse.push(car);
  }

  return [...diverse, ...deferred];
}